export interface UserPayloadInterface {
    email: string;
    password: string;
    token: string|undefined;
}

export interface LoginForm {
    email: string | null;
    password: string | null;
    terms_agreement: boolean | null;
}

export interface ValidationLoginStatus {
    email: boolean | null;
    password: boolean | null;
    terms_agreement: boolean | null;
    [key: string]: boolean | null;
}

export const createDefaultLoginForm = (): LoginForm => {
    return {
        email: null,
        password: null,
        terms_agreement: false,
    }
}

export const createDefaultValidationLoginStatus = (): ValidationLoginStatus => {
    return {
        email: false,
        password: false,
        terms_agreement: false,
    }
}

export interface AuthResponse {
    access_token: string;
    user: ApiUser;
    max_age: number;
}

export interface ApiUser {
    id: number;
    last_name: string;
    first_name: string;
    email: string;
    phone_number: string;
    default_language_id: number;
    full_name: string;
}